export default "/confirm-account";
